<template>
  <v-main>
    <v-layout fill-height column align-center justify-center>
      <v-container class="error-container">
        <div class="guide">
          <v-img :src="getImage(guideInfo.question)" max-width="100px" class="mx-auto mb-3" />
        </div>
        <h2>잘못된 접근입니다. </h2>
        <p>
          찾으시는 페이지가 존재하지 않습니다.<br />
          다시 확인하시고 이용해 주세요.
        </p>
        <v-btn elevation="0" min-width="140px" color="primary" class="mt-5">
          <span class="fs-14" @click="sendRoute('/')">메인으로</span>
        </v-btn>
      </v-container>
    </v-layout>
  </v-main>
</template>

<script>
import {mixinRemote} from "@/mixins";

export default {
  name: 'NotFound',
  components: {},
  mixins: [mixinRemote],
  props: {},
  data: () => ({}),
  computed: {},
  watch: {},
  created() {
  },
  mounted() {
  },
  methods: {
    sendRoute (to) {
      this.$router.replace(to)
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep.error-container {
  padding-bottom: 60px;
  text-align: center;
  color: #999;
  h2 {
    margin-bottom: 5px;
    font-weight: 600;
    font-size: 18px;
    color: #333;
  }
}
</style>
